import { defineMessages } from "react-intl";

export const messages = defineMessages({
  buttonLabel: {
    id: "button.updateMeetingParticipants.label",
    defaultMessage: "Update",
    description: "change button label",
  },
});
